<template>
    <v-main>
        <v-row class="pa-0 ma-0">
            <v-col cols="12" class="pa-0 pt-2 ma-0">
                <hsiiMessages ref="hsiiMessages" :huis_encrid="huis_encrid"/>
            </v-col>
            <v-col cols="6" class="pa-0 pt-2 ma-0">
                <hsiiView ref="hsiiView" :huis_encrid="huis_encrid" @refreshLayout="refreshLayout" @newDetails="newDetails" @selectItem="selectItem"/>
            </v-col>
            <v-col cols="3" class="pa-0 ma-0">
                <hsiiItems ref="hsiiItems" @newItem="newItem" @dragEnd="dragEnd"/>
            </v-col>
            <v-col cols="3" class="pa-0 ma-0">
                <hsiiItemDetails ref="hsiiItemDetails" :key="hsii_id" :huis_encrid="huis_encrid" :hsii_id="hsii_id" @refreshLayout="refreshLayout"/>
            </v-col>
        </v-row> 
        <navbar title="Ares - Layout" :home="true"/>
    </v-main>
</template>

<script>
    import navbar from "@/components/ui/navbars/navbar.vue";
    import hsiiView from "@/components/huis/hsii/hsiiView";
    import hsiiItems from "@/components/huis/hsii/hsiiItems";
    import hsiiMessages from "@/components/huis/hsii/hsiiMessages";
    import hsiiItemDetails from "@/components/huis/hsii/hsiiItemDetails";
    
    export default {
        components: {
            navbar,
            // hsiiHeader,
            hsiiMessages,
            hsiiView,
            hsiiItems,
            hsiiItemDetails,
        },
        props: {
            huis_encrid: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                hsii_id: "",
            } 
        },
        mounted() {
            // this.refreshLayout();
        },
        methods: {
            refreshLayout() {
                this.$refs.hsiiMessages.getMessages();
                this.$refs.hsiiView.getHsiiOverview();
            },
            newItem(data) {
                this.$refs.hsiiView.newItem(data);
            },
            newDetails(hsii_id) {
                this.hsii_id = hsii_id;
                this.$refs.hsiiMessages.selectItem(hsii_id);
            },
            selectItem(itemId) {
                this.$refs.hsiiMessages.selectItem(itemId);
            },
            dragEnd() {
                this.$refs.hsiiView.dragEnd();
            }
        }  
    }
</script> 
